import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { RecruitmentAuth } from "./recruitment-auth";
import { Observable } from "rxjs";

@Injectable()
export class RecruitmentApi {

    // private basePath: string = "https://api.greatdayhr.com/";
    public basePath: any;

    constructor(
        private http: HttpClient,
        private recruitmentAuth: RecruitmentAuth
    ) { }

    public urlBuilder(method: string, model: string, func: string, params: any, urlParams: any): string {
        const path: string = this.recruitmentAuth.getPath();
        this.basePath = `https://api.greatdayhr.com/${path}`;
        switch (method) {
            case 'GET':
                return `${this.basePath}/${model}/${func}?${new URLSearchParams(this._JSON2URL(urlParams, false))}`;
            case 'POST':
                return `${this.basePath}/${model}/${func}?${new URLSearchParams(this._JSON2URL(urlParams, false))}`;
            case 'DELETE':
                return `${this.basePath}/${model}/${func}?${new URLSearchParams(this._JSON2URL(urlParams, false))}`;
            case 'PUT':
                return `${this.basePath}/${model}/${func}?${new URLSearchParams(this._JSON2URL(urlParams, false))}`;
        }
    }

    public request<T>(method: string, url: string, params: any, urlParams: any, body: any, contentType?: string, timeOut: number = 30000, sendToken = false): Observable<T> {
        let headers: any;
        if (sendToken) {
            headers = new HttpHeaders({ timeout: `${timeOut}` })
            .set('Authorization', this.recruitmentAuth.getAccessToken())
            .append('Content-Type', 'application/json');
        } else {
            headers = new HttpHeaders({ timeout: `${timeOut}` })
            // .set('Authorization', this.recruitmentAuth.getAccessToken())
            .append('Content-Type', 'application/json');
        }

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                // 'Authorization': this.recruitmentAuth.getAccessToken()
            }), body: params
        };

        switch (method) {
            case 'GET':
                return this.http.get<T>(url, { headers });
            case 'POST':
                return this.http.post<T>(url, params, { headers });
            case 'DELETE':
                return this.http.delete<T>(url, httpOptions);
            case 'PUT':
                return this.http.put<T>(url, params, { headers });
        }
    }

    private _JSON2URL(obj: any, parent: any) {
        const parts: any = [];
        for (const key in obj)
            parts.push(this._parseParam(key, obj[key], parent));
        return parts.join('&');
    }

    private _parseParam(key: string, value: any, parent: string) {
        let processedKey = parent ? parent + '[' + key + ']' : key;
        if (value && (<string>(typeof value) === 'object' || Array.isArray(value))) {
            return this._JSON2URL(value, processedKey);
        }
        return processedKey + '=' + value;
    }


}


// WEBPACK FOOTER //
// ./src/shared/recruitment/recruitment-api.ts